'use client';

import { useTranslations } from '@/lib/i18n';
import { cn } from '@/lib/utils';


interface CookieSettingsLinkProps {
  label?: string;
  className?: string;
}

export function CookieSettingsLink({
  label,
  className,
}: CookieSettingsLinkProps) {
  const t = useTranslations('components.cookie-settings-link');
  return (
    <button
      type="button"
      onClick={() => window.PinkdudeCookieConsent?.showPreferences?.()}
      className={cn('inline-flex min-h-11 items-center md:min-h-0', className ?? 'text-sm text-muted-foreground hover:text-foreground transition-colors cursor-pointer')}
    >
      {label ?? t('cookie-settings')}
    </button>
  );
}
